// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: TIPg3d7a_Mt_
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import ApplicationKeys from "../../ApplicationKeys"; // plasmic-import: NYeibxDv3Ojc/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDeveloper2.module.css"; // plasmic-import: TIPg3d7a_Mt_/css

createPlasmicElementProxy;

export const PlasmicDeveloper2__VariantProps = new Array();

export const PlasmicDeveloper2__ArgProps = new Array();

const $$ = {};

function PlasmicDeveloper2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__cut7I)}>
            <div className={classNames(projectcss.all, sty.freeBox__clMn)}>
              <div className={classNames(projectcss.all, sty.freeBox__j9Fa0)}>
                <div className={classNames(projectcss.all, sty.freeBox__liB)}>
                  <ApplicationKeys
                    data-plasmic-name={"applicationKeys"}
                    data-plasmic-override={overrides.applicationKeys}
                    className={classNames(
                      "__wab_instance",
                      sty.applicationKeys
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "sidebar", "applicationKeys"],
  sidebar: ["sidebar"],
  applicationKeys: ["applicationKeys"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDeveloper2__ArgProps,
          internalVariantPropNames: PlasmicDeveloper2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDeveloper2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDeveloper2";
  } else {
    func.displayName = `PlasmicDeveloper2.${nodeName}`;
  }
  return func;
}

export const PlasmicDeveloper2 = Object.assign(
  // Top-level PlasmicDeveloper2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    applicationKeys: makeNodeComponent("applicationKeys"),
    // Metadata about props expected for PlasmicDeveloper2
    internalVariantProps: PlasmicDeveloper2__VariantProps,
    internalArgProps: PlasmicDeveloper2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicDeveloper2;
/* prettier-ignore-end */
